<template>
  <div v-loading="loading">
    <div v-if="inventoryInfo">
      <el-card shadow="hover">
        <div style="padding: 10px">
          <warehouse-inventory-info
            :inventoryInfo="inventoryInfo"
            :disableClick="true"
            :showState="false"
          />
          <div style="margin-top: 10px" v-if="inventoryInfo.optCancel == 0">
            <el-button @click="printReceiptClick"> 打印 </el-button>
            <el-button
              v-if="inventoryInfo.inventoryType == 'stock_split'"
              @click="printSplitClick"
              type="primary"
            >
              打印拆零标签
            </el-button>
            <el-button @click="cancelClick" type="danger"> 取消 </el-button>
          </div>
        </div>
      </el-card>
      <x-tab :tabs="tabs" :query="detailData" :params="detailData" />
    </div>
    <el-empty v-else-if="!loading" :description="errorMsg" :image-size="100">
      <el-button v-if="errorMsg" @click="getDetail" size="small">
        重新加载
      </el-button>
    </el-empty>

    <el-dialog
      title="提示"
      append-to-body
      :show-close="false"
      :destroy-on-close="true"
      :close-on-press-escape="false"
      :visible="printLoading"
      width="400px"
    >
      <span>
        <i class="el-icon-loading"></i>
        正在打印中
      </span>
    </el-dialog>
  </div>
</template>

<script>
import warehouseInventoryInfo from '../../../../components/business/warehouseInventoryInfo.vue';
import itemInventoryList from './__detail_item_list.vue';

export default {
  components: {
    itemInventoryList,
    warehouseInventoryInfo,
  },
  props: {
    params: {
      type: Object,
      default: () => {
        return {};
      },
    },
    query: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    tabs() {
      if (!this.inventoryInfo) {
        return [];
      }
      return [{
        name: "inventory-itemlist",
        label: "清单列表",
        component: itemInventoryList,
        interval: true,
      }];
    },
    detailData() {
      if (!this.inventoryInfo) {
        return {};
      }
      return {
        guid: this.inventoryInfo.guid,
        inventoryGuid: this.inventoryInfo.guid,
        storeGuid: this.inventoryInfo.storeGuid,
      }
    },
    pageParams() {
      return Object.assign({},
        (this.$route && this.$route.params) || {},
        this.params
      );
    },
    pageQuery() {
      return Object.assign({},
        (this.$route && this.$route.query) || {},
        this.query
      );
    },
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      inventoryInfo: null,
      printLoading: false
    }
  },
  methods: {
    cancelClick() {
      if (!this.inventoryInfo) {
        return;
      }
      this.$confirm(`确定取消出入库操作，此操作不可恢复，请谨慎操作?`, '提示', {
        type: 'warning',
      }).then(() => {
        this.requestApi('biz.warehouse.inventory.info.cancel', {
          guid: this.inventoryInfo.guid,
          storeGuid: this.inventoryInfo.storeGuid
        }, { showError: true }).then(() => {
          this.$drawer.refreshDrawer();
          this.getDetail();
        });
      });
    },
    printReceiptClick() {
      if (!this.inventoryInfo) {
        return;
      }
      this.printInventory(this.inventoryInfo);
    },
    printSplitClick() {
      if (!this.inventoryInfo) {
        return;
      }
      this.printLoading = true;
      this.requestApi('biz.warehouse.inventory.info.printSplit', {
        guid: this.inventoryInfo.guid,
        storeGuid: this.inventoryInfo.storeGuid
      }, { showAlert: true }).finally(() => {
        this.printLoading = false;
      });
    },
    getDetail() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.errorMsg = null;
      return this.requestApi('biz.warehouse.inventory.info.detail', {
        guid: this.pageParams.guid,
        storeGuid: this.pageParams.storeGuid
      }).then((resp) => {
        this.loading = false;
        this.inventoryInfo = resp.data;
      }).catch((err) => {
        this.loading = false;
        this.errorMsg = (err && err.msg) || (err && err.message) || '连接服务器失败，请检查网络';
      });
    }
  },
  mounted() {
    this.getDetail();
  }
}
</script>
